import { msg } from 'gt-react';
import { FileXlsIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../../route';

const Sd844ConfigurationPage = lazyRouteComponent(
  () => import('./Sd844ConfigurationPage'),
  'Sd844ConfigurationPage',
);

/**
 * Open to the whole S&D team, not just admins: viewing needs 844 transaction
 * read; changing a template needs 844 transaction update (enforced on the
 * server and mirrored in the page).
 */
export const SD_844_CONFIGURATION_ACCESS = [
  { action: Action.Read, subject: Subject.SDTransaction },
  { action: Action.Read, subject: Subject.SDAdmin },
];

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/844-configuration',
  staticData: {
    app: {
      nav: {
        label: msg('844 Configuration', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <FileXlsIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 22,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: SD_844_CONFIGURATION_ACCESS,
      },
    },
  },
  component: Sd844ConfigurationPage,
  loader: () => ({
    crumb: msg('844 Configuration', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.SHIP_AND_DEBIT] });
    await requireAnyPermission({
      context,
      permissions: SD_844_CONFIGURATION_ACCESS,
    });
  },
});
